import React, { useEffect, useState } from "react";
import { Card, Typography } from "antd";
import useQuery from "../../../../hooks/useQuery";
import { getInPatientDetailsApi } from "../../../../services/receptionist.services";
import dayjs from "dayjs";

import facilityIcon from "../../../../assets/patientDetails/facility.svg";
import startDateIcon from "../../../../assets/patientDetails/startDate.svg";
import genderIcon from "../../../../assets/patientDetails/gender.svg";
import ageIcon from "../../../../assets/patientDetails/age.svg";
import emailIcon from "../../../../assets/patientDetails/email.svg";
import phoneIcon from "../../../../assets/patientDetails/phone.svg";
import consultantIcon from "../../../../assets/patientDetails/consultant.svg";
import bloodGroupIcon from "../../../../assets/patientDetails/bloodGroup.svg";
import maritalStatusIcon from "../../../../assets/patientDetails/maritalStatus.svg";
import addressIcon from "../../../../assets/patientDetails/address.svg";
import insuranceNameIcon from "../../../../assets/patientDetails/insuranceName.svg";
import insuranceIdIcon from "../../../../assets/patientDetails/insuranceId.svg";
import occupationIcon from "../../../../assets/patientDetails/occupation.svg";
import govtIdIcon from "../../../../assets/patientDetails/govtId.svg";
import primaryConsultantIcon from "../../../../assets/patientDetails/primaryConsultant.svg";
import primaryHospitalIcon from "../../../../assets/patientDetails/primaryHospital.svg";
import emergencyContactIcon from "../../../../assets/patientDetails/emergencyContact.svg";
import emergencyPhoneIcon from "../../../../assets/patientDetails/emergencyPhone.svg";
import messageIcon from "../../../../assets/patientDetails/message.svg";
import styles from "./PackagesIp.module.css";

const PatientDetails = () => {
  const [patientDetails, setPatientDetails] = useState({});
  const params = useQuery();

  useEffect(() => {
    getInPatientDetailsApi(params?.patient)
      .then((res) => setPatientDetails(res?.data))
      .catch((err) => console.log(err));
  }, [params?.patient]);

  const renderRow = (icon, label, value) => (
    <div key={label} className={styles.infoRow}>
      <div className={styles.infoRowLeft}>
        <img src={icon} alt="" className={styles.infoRowIcon} />
        <span className={styles.infoRowLabel}>{label}</span>
      </div>
      <span className={styles.infoRowValue}>
        {value ?? <span className={styles.infoRowEmpty}>----------</span>}
      </span>
    </div>
  );

  const basicRows = [
    {
      icon: facilityIcon,
      label: "Facility",
      value: patientDetails?.facility_name,
    },
    {
      icon: startDateIcon,
      label: "Start Date",
      value: patientDetails?.admission_date
        ? dayjs(patientDetails.admission_date).format("DD MMM YYYY")
        : null,
    },
    {
      icon: genderIcon,
      label: "Gender",
      value: patientDetails?.patient_gender ?? null,
    },
    {
      icon: ageIcon,
      label: "Age",
      value: patientDetails?.patient_age
        ? `${patientDetails.patient_age} years`
        : null,
    },
    { icon: emailIcon, label: "Email", value: patientDetails?.patient_email },
    {
      icon: phoneIcon,
      label: "Phone number",
      value: patientDetails?.patient_mobile,
    },
    {
      icon: consultantIcon,
      label: "Consultant name",
      value:
        patientDetails?.doctor_first_name || patientDetails?.doctor_last_name
          ? `Dr ${patientDetails?.doctor_first_name ?? ""} ${
              patientDetails?.doctor_last_name ?? ""
            }`.trim()
          : null,
    },
  ];

  const moreRows = [
    {
      icon: bloodGroupIcon,
      label: "Blood Group",
      value: patientDetails?.patient_blood_group,
    },
    {
      icon: maritalStatusIcon,
      label: "Marital Status",
      value: patientDetails?.patient_marital_status,
    },
    {
      icon: addressIcon,
      label: "Permanent Address",
      value: patientDetails?.patient_permenant_address,
    },
    {
      icon: insuranceNameIcon,
      label: "Insurance Corporate Name",
      value: patientDetails?.insurance_corporate_name,
    },
    {
      icon: insuranceIdIcon,
      label: "Insurance Corporate ID",
      value: patientDetails?.insurance_corporate_id,
    },
    {
      icon: occupationIcon,
      label: "Occupation",
      value: patientDetails?.patient_occuption,
    },
    {
      icon: govtIdIcon,
      label: "Government ID No",
      value: patientDetails?.patient_govt_id_no,
    },
    {
      icon: primaryConsultantIcon,
      label: "Primary Consultant Name",
      value:
        patientDetails?.primary_consultant_details?.length > 0
          ? patientDetails.primary_consultant_details
              .map((c) => c.primary_consultant_name)
              .join(", ")
          : patientDetails?.primary_consultant_name || null,
    },
    {
      icon: primaryHospitalIcon,
      label: "Primary Hospital Name",
      value:
        patientDetails?.primary_consultant_details?.length > 0
          ? patientDetails.primary_consultant_details
              .map((c) => c.primary_consultant_hospital)
              .filter(Boolean)
              .join(", ") || null
          : null,
    },
    {
      icon: emergencyContactIcon,
      label: "Emergency Contact Name",
      value: patientDetails?.emergency_contact_name,
    },
    {
      icon: emergencyPhoneIcon,
      label: "Emergency Contact Number",
      value: patientDetails?.emergency_contact_no,
    },
    {
      icon: messageIcon,
      label: "Message",
      value: patientDetails?.message,
    },
  ];

  return (
    <>
      <Card
        title={
          <Typography.Text strong style={{ fontSize: 14, color: "#101828" }}>
            Basic Information
          </Typography.Text>
        }
        className={`details-card ${styles.basicInfoCard}`}
        bodyStyle={{ padding: "16px 20px" }}
        headStyle={{ background: "#fff", borderBottom: "1px solid #F3F4F6" }}
        style={{ borderRadius: 12, border: "1px solid #E5E7EB" }}
      >
        <div className={styles.infoRows}>
          {basicRows.map((row) => renderRow(row.icon, row.label, row.value))}
        </div>
      </Card>

      <Card
        className="details-card"
        title={
          <Typography.Text strong style={{ fontSize: 14, color: "#101828" }}>
            More Information
          </Typography.Text>
        }
        bodyStyle={{ padding: "16px 20px" }}
        headStyle={{ background: "#fff", borderBottom: "1px solid #F3F4F6" }}
        style={{ marginTop: 8, borderRadius: 12, border: "1px solid #E5E7EB" }}
      >
        <div className={styles.infoRows}>
          {moreRows.map((row) => renderRow(row.icon, row.label, row.value))}
        </div>
      </Card>
    </>
  );
};

export default PatientDetails;
